import { render } from "react-dom";
import { createElement } from "react";
import MoreSetting from "./moreSetting/moreSetting"
import { emitCustomEvent } from "./emitCustomEvent";
import AISubtitleSetting from "./aiSubtitleSetting/aiSubtitleSetting"


const settingRender = (argus: any) => {
    render(
        createElement(AISubtitleSetting, {
            ...argus
        }),
        argus.container
    );
}

const moreSettingRender = (argus: any) => {
    render(
        createElement(MoreSetting, {
            ...argus,
        }),
        argus.container,
    );
}

export default { AISubtitleSetting, MoreSetting, settingRender,moreSettingRender, emitCustomEvent};